import { Link } from 'react-router-dom';
import { categories } from '@/mocks/shows';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-heading text-white">天天影视</span>
            </div>
            <p className="text-sm text-background-400 mb-4 leading-relaxed">
              天天影视致力于为用户提供最新最全的综艺节目在线观看服务。热门综艺、真人秀、脱口秀、音乐综艺，高清免费、流畅不缓冲，天天更新，让您随时随地享受精彩综艺内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-medium mb-4">综艺分类</h4>
            <ul className="space-y-2.5">
              {categories.filter((c) => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-medium mb-4">热门推荐</h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/show-3" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">中国好声音 2026</Link></li>
              <li><Link to="/article/show-7" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">创造营2026</Link></li>
              <li><Link to="/article/show-1" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">奔跑吧·兄弟 第十二季</Link></li>
              <li><Link to="/article/show-17" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">乘风破浪的姐姐 第五季</Link></li>
              <li><Link to="/article/show-9" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">歌手·当打之年 2026</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-medium mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">版权声明</a></li>
            </ul>
            <div className="mt-5 pt-5 border-t border-background-800">
              <p className="text-sm text-background-400">
                <i className="ri-mail-line mr-1"></i> contact@tiantian.tv
              </p>
              <p className="text-sm text-background-400 mt-1">
                <i className="ri-phone-line mr-1"></i> 400-888-6666
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 天天影视 TianTian.tv - 版权所有
          </p>
          <p className="text-sm text-background-500">
            京ICP备2024000001号 | 广播电视节目制作经营许可证
          </p>
        </div>
      </div>
    </footer>
  );
}